import { CourseService } from '@services/courseService';
import { useQuery } from '@tanstack/react-query';

export type UseCoursesParams = {
  searchText?: string;
  page?: number;
  pageSize?: number;
  visibility?: Course['visibility'];
};

export const useCourses = (params?: UseCoursesParams) => {
  return useQuery({
    initialData: {
      data: [],
      total: 0,
      page: 1,
      pageSize: 10,
    },
    queryKey: ['courses', params],
    queryFn: () => CourseService.getAll(params),
  });
};
